import { Map, List } from 'immutable';

import {
  REGISTER_AUTOCOMPLETE,
  UNREGISTER_AUTOCOMPLETE,
  SET_DATA_SOURCE,
  UNREGISTER_ALL_AUTOCOMPLETES,
  SET_CHOSEN_TEXT,
  SET_ORIGIN,
  SET_PRELOAD,
} from './constants';

import { FIELD_REMOVED } from '@/components/SubForm/constants';

const initialState = Map({
  preloads: Map({}),
});

export default (state = initialState, action: any) => {
  switch (action.type) {
    case REGISTER_AUTOCOMPLETE: {
      return state.set(
        action.name,
        Map({
          textField: action.textField,
          dataSource: List([]),
          origin: List([]),
          url: action.url,
          chosenText: '',
        }),
      );
    }

    case UNREGISTER_AUTOCOMPLETE: {
      return state.delete(action.name);
    }

    case UNREGISTER_ALL_AUTOCOMPLETES: {
      return initialState;
    }

    case SET_DATA_SOURCE: {
      return state.setIn(
        [action.name, 'dataSource'],
        action.data.map((d: any) => ({
          text: d[action.textField],
          value: d.id,
        })),
      );
    }

    case SET_ORIGIN: {
      return state.setIn([action.name, 'origin'], action.items);
    }

    case SET_CHOSEN_TEXT: {
      return state.setIn([action.name, 'chosenText'], action.text);
    }

    case FIELD_REMOVED: {
      const keys = state
        .keySeq()
        .filter(
          (k: string, i: number) =>
            k.indexOf(action.name.split('[')[0]) === 0 && +k.match(/\[(\d+)\]/)[1] >= action.index,
        )
        .toJS();

      const maxIndex = keys.reduce((max, k) => {
        const index = +k.match(/\[(\d+)\]/)[1];
        return index > max ? index : max;
      }, 0);

      return state.withMutations((s: Map<any, any>) => {
        keys
          .sort((a, b) => {
            const indexA = +a.match(/\[(\d+)\]/)[1];
            const indexB = +b.match(/\[(\d+)\]/)[1];
            return indexA - indexB;
          })
          .map((k) => {
            const index = +k.match(/\[(\d+)\]/)[1];
            index !== maxIndex ? s.set(k, s.get(k.replace(/\[(\d+)\]/, `[${index + 1}]`))) : s.delete(k);
          });
      });
    }

    case SET_PRELOAD: {
      return state.setIn(['preloads', action.name], action.preload);
    }

    default: {
      return state;
    }
  }
};
